import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AreaChart, Area, Legend, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { connect } from 'react-redux';
import * as styles from './Reports.scss';
var PageChart = (_dec = connect(function (state) {
  return {
    theme: state.theme
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(PageChart, _Component);

  var _super = _createSuper(PageChart);

  function PageChart(props) {
    var _this;

    _classCallCheck(this, PageChart);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "formatChartTitle", function (title) {
      var t = title.split('_');
      var u = t.map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      });
      return u.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "formatChartLabel", function (label) {
      var l = _this.formatChartTitle(label);

      var m = l.split(' ');
      m.shift();
      return m.length > 1 ? m.join(' ') : m[0];
    });

    _defineProperty(_assertThisInitialized(_this), "onPeriodSwitch", function (period) {
      _this.setState({
        loading: true,
        period: null
      });

      var periodArg = period === 'week' ? 'LAST_7_DAYS' : 'LAST_30_DAYS';

      _this.props.onPeriodSwitch(periodArg, _this.props.metric).then(function () {
        return _this.setState({
          period: period,
          loading: false
        });
      });
    });

    _this.state = {
      period: 'week'
    };
    return _this;
  }

  _createClass(PageChart, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          metric = _this$props.metric,
          theme = _this$props.theme,
          style = _this$props.style;
      var viewData = this.state.loading ? data.map(function (d) {
        return _objectSpread(_objectSpread({}, d), {}, {
          uv: 0
        });
      }) : data;
      return /*#__PURE__*/React.createElement("div", {
        style: style
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles.chartTitle
      }, this.props.label), /*#__PURE__*/React.createElement(ResponsiveContainer, {
        width: "100%",
        height: 250
      }, /*#__PURE__*/React.createElement(AreaChart, {
        data: viewData,
        margin: {
          top: 10,
          right: 30,
          left: 0,
          bottom: 0
        }
      }, /*#__PURE__*/React.createElement(XAxis, {
        dataKey: "name",
        tickSize: 10
      }), /*#__PURE__*/React.createElement(YAxis, {
        tickSize: 10
      }), /*#__PURE__*/React.createElement(CartesianGrid, {
        strokeDasharray: "3 3"
      }), /*#__PURE__*/React.createElement(Tooltip, null), /*#__PURE__*/React.createElement(Area, {
        name: this.props.label,
        type: "monotone",
        dataKey: "uv",
        stroke: theme.colors.secondaryColor,
        fill: theme.colors.secondaryColor
      }))), /*#__PURE__*/React.createElement("div", {
        className: styles.chartPeriodWrap
      }, this.state.loading ? /*#__PURE__*/React.createElement("div", null, "Loading...") : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        style: {
          textDecoration: this.state.period === 'week' ? 'underline' : 'none'
        },
        className: styles.chartPeriodToggle,
        onClick: function onClick() {
          return _this2.onPeriodSwitch('week');
        }
      }, "Week"), /*#__PURE__*/React.createElement("span", {
        style: {
          textDecoration: this.state.period === 'month' ? 'underline' : 'none'
        },
        className: styles.chartPeriodToggle,
        onClick: function onClick() {
          return _this2.onPeriodSwitch('month');
        }
      }, "Month"))));
    }
  }]);

  return PageChart;
}(Component), _defineProperty(_class2, "propTypes", {
  data: PropTypes.object.isRequired,
  theme: PropTypes.object,
  metric: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onPeriodSwitch: PropTypes.func.isRequired
}), _temp)) || _class);
PageChart.defaultProps = {
  style: {}
};
export default PageChart;